module.exports = __webpack_public_path__ + "media/images/prize__saint-drivetrain-6646e8c91b40ec88ab4eff83c42867c1.jpg";